module.exports = __webpack_public_path__ + "img/artzie_logo_se_cut.d2a357cb.png";